module.exports = {
      id: "next-story-usage",
      viewBox: "0 0 40 40",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#next-story",
      toString: function () {
        return this.url;
      }
    }